import { ApiKeyHttpService } from '../services/api-key-http.service';
import { ArchiveConfigHttpService } from '../services/archive-config-http.service';
import { AuthHttpService } from '../services/auth-http.service';
import { BuildInfoHttpService } from '../services/build-info-http.service';
import { ChatHttpService } from '../services/chat-http.service';
import { ClientSpaceHttpService } from '../services/client-space-http.service';
import { DashboardHttpService } from '../services/dashboard-http.service';
import { DBConnectorHttpService } from '../services/db-connector-http.service';
import { EmailTemplateHttpService } from '../services/email-template-http.service';
import { ExecutionHistoryHttpService } from '../services/execution-history-http.service';
import { ExecutionSimulatorHttpService } from '../services/execution-simulator-http.service';
import { ExpressionParserHttpService } from '../services/expression-parser-http.service';
import { FileReaderHttpService } from '../services/file-reader-http.service';
import { FileUploadHttpService } from '../services/file-upload-http.service';
import { FileWriterHttpService } from '../services/file-writer-http.service';
import { FlowHttpService } from '../services/flow-http.service';
import { FlowImportExportHttpService } from '../services/flow-import-export-http.service';
import { HubSpotConnectionHttpService } from '../services/hubspot-connection-http.service';
import { HubSpotHttpService } from '../services/hubspot-http.service';
import { ProjectSpaceHttpService } from '../services/project-http.service';
import { RagAiHttpService } from '../services/rag-ai-http.service';
import { RoleHttpService } from '../services/role-http.service';
import { S3ConnectorHttpService } from '../services/s3-connector-http.service';
import { SalesforceHttpService } from '../services/salesforce-http.service';
import { SchemaHttpService } from '../services/schema-http.service';
import { ScopedPermissionsConfigHttpService } from '../services/scoped-permissions-config-http.service';
import { SecretsHttpService } from '../services/secrets-http.service';
import { SftpReaderHttpService } from '../services/sftp-reader-http.service';
import { SystemSettingsHttpService } from '../services/system-settings-http.service';
import { TaskExecutorHttpService } from '../services/task-executor-http.service';
import { TaskHttpService } from '../services/task-http.service';
import { TenantManagementHttpService } from '../services/tenant-management-http.service';
import { UniqueHistoryConfigHttpService } from '../services/unique-history-http.service';
import { UserHttpService } from '../services/user-http.service';
import { VariableHttpService } from '../services/variable-http.service';
import { WhitelistIpHttpService } from '../services/whitelist-ip-http.service';
import { XeroConnectionHttpService } from '../services/xero-connection-http.service';
import { XeroHttpService } from '../services/xero-http.service';

export default class HttpServices {
	static buildInfo = new BuildInfoHttpService();
	static auth = new AuthHttpService();
	static chat = new ChatHttpService();
	static clientSpace = new ClientSpaceHttpService();
	static flow = new FlowHttpService();
	static task = new TaskHttpService();
	static taskExecutor = new TaskExecutorHttpService();
	static projectSpace = new ProjectSpaceHttpService();
	static schema = new SchemaHttpService();
	static variable = new VariableHttpService();
	static executionHistory = new ExecutionHistoryHttpService();
	static user = new UserHttpService();
	static role = new RoleHttpService();
	static apiKey = new ApiKeyHttpService();
	static archiveConfig = new ArchiveConfigHttpService();
	static uniqueHistoryConfig = new UniqueHistoryConfigHttpService();
	static dbConnector = new DBConnectorHttpService();
	static executionSimulator = new ExecutionSimulatorHttpService();
	static sftpReader = new SftpReaderHttpService();
	static secrets = new SecretsHttpService();
	static fileUpload = new FileUploadHttpService();
	static s3Connector = new S3ConnectorHttpService();
	static fileReader = new FileReaderHttpService();
	static fileWriter = new FileWriterHttpService();
	static salesforce = new SalesforceHttpService();
	static hubSpot = new HubSpotHttpService();
	static hubSpotConnection = new HubSpotConnectionHttpService();
	static whitelistIp = new WhitelistIpHttpService();
	static tenantManagement = new TenantManagementHttpService();
	static flowImportExport = new FlowImportExportHttpService();
	static systemSettings = new SystemSettingsHttpService();
	static expressionParser = new ExpressionParserHttpService();
	static ragAi = new RagAiHttpService();
	static emailTemplate = new EmailTemplateHttpService();
	static dashboard = new DashboardHttpService();
	static xero = new XeroHttpService();
	static xeroConnection = new XeroConnectionHttpService();
	static scopedUsers = new ScopedPermissionsConfigHttpService();
}
